import React from 'react'
import { useTranslation } from 'react-i18next'
import { ProductFruits } from 'react-product-fruits'
import { useSelector } from 'react-redux'
import Config from '../config'

function ProductFruitsWrapper() {
  const { i18n } = useTranslation()
  const ssoUser = useSelector(state => state.auth.ssoUser)
  const profile = useSelector(state => state.auth.profile)

  if (!Config.productFruits.enabled || !ssoUser || !profile) {
    return null
  }

  const language = i18n.language?.toLowerCase().substring(0, 2) || 'en'
  const rest = {
    current_community_id: null,
    current_community_plan_name: null,
    current_community_non_paying_client: null,
    current_community_new_comms_experience: null,
  }

  if (profile.current_community) {
    rest.current_community_id = profile.current_community.id
    rest.current_community_plan_name = profile.current_community.tiering_plan_name
    rest.current_community_non_paying_client = profile.current_community.temp_non_paying_client
    rest.current_community_new_comms_experience = profile.current_community.new_comms_experience
  }

  return (
    <ProductFruits
      workspaceCode={Config.productFruits.workspaceCode}
      language={language}
      user={{
        username: profile.email,
        email: profile.email,
        firstname: profile.first_name,
        lastname: profile.last_name,
        props: {
          user_id: profile.id,
          ...rest,
        },
      }}
      lifeCycle='neverUnmount'
    />
  )
}

export default ProductFruitsWrapper
